import { TicketProcessingStateEnum } from "@/api/hausify";

export const processingStateTypes = [
  {
    id: TicketProcessingStateEnum.New,
    name: "Neu",
    i18n: "ticket.processing_state.new",
  },
  {
    id: TicketProcessingStateEnum.InProgress,
    name: "In Bearbeitung",
    i18n: "ticket.processing_state.in_progress",
  },
  {
    id: TicketProcessingStateEnum.WorkDone,
    name: "Erledigt",
    i18n: "ticket.processing_state.done",
  },
] as const;
